import { render, staticRenderFns } from "./CreateCA.vue?vue&type=template&id=3f36b7f6&scoped=true&"
import script from "./CreateCA.vue?vue&type=script&lang=js&"
export * from "./CreateCA.vue?vue&type=script&lang=js&"
import style0 from "./CreateCA.vue?vue&type=style&index=0&id=3f36b7f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f36b7f6",
  null
  
)

export default component.exports